import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { UserInfoContext } from "../../contexts/UserInfo.context";
import { apiService } from "../../services/api.service";
import { getDateTime } from "../../utils";
import { StatusContext } from "../../contexts/Status.context";
import useTranslation from "../../hooks/useTranslation";
import CommonBtn from "../../components/buttons/commonBtn";
import { FaFacebook, FaLinkedinIn, FaTwitter } from "react-icons/fa";

const FinishSectionFree = () => {
  const { ip, score, userId, setScore } = useContext(UserInfoContext);
  const { module, setProblemNumber, setPageStatus, setEngine, setMechanics } =
    useContext(StatusContext);
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [fullname, setFullname] = useState("");

  const saveMainScore = async () => {
    try {
      const dateTime = getDateTime();
      const data = `score=${dateTime},${userId.replaceAll(
        ",",
        " "
      )},${email},${ip},${score},${module}`;
      // const result = await apiService.saveMainScore(data);
    } catch (error) {}
  };

  useEffect(() => {
    saveMainScore();
  }, []);

  const returnToHome = () => {
    setPageStatus("Free Test");
    setMechanics(0);
    setEngine("test");
    setProblemNumber(0);
    setScore(0);
  };

  return (
    <div>
      <div className="text-center px-8">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-3 md:col-span-2">
            <div className="mt-4 mb-4 text-2xl font-bold">
              {t("Your Score")}: {Number(score) >= 0 ? score : 0} %
            </div>
            <div className="my-8">
              Participants of the METV program achieve scores on average of 85%
              after just one hour of training.
              {/* <CommonBtn status={3} onClick={() => returnToHome()}>
                {t("Return to main menu")}
              </CommonBtn> */}
            </div>
            <div className="mt-16 text-center">
              <button
                className={`common-btn common-btn-status-${3} full-metv-training`}
                onClick={() => {
                  window.open(
                    "http://www.microexpressionstrainingvideos.com/pricing/",
                    "_blank"
                  );
                }}
              >
                {t("Full METV Training")}
              </button>
              <a
                href="http://www.microexpressionstrainingvideos.com/pricing/"
                target="_blank"
              >
                <div className="mt-1 hover:text-orange-500">
                  &gt;&gt; Buy our full Micro Expressions Training program to
                  exercise with 300+ videos
                </div>
              </a>
            </div>
            <div className="mt-16 mb-2 text-2xl font-bold">
              {t("SHARE YOUR SCORE")}
            </div>
            <div className="w-[90%] md:w-[60%] mx-auto flex justify-between">
              <a
                href="https://twitter.com/intent/tweet?text=Members&url=https%3A%2F%2Fmicroexpressionstrainingvideos.com%2Fmembers%2F"
                target="_blank"
                className="mx-2 bg-[#1da1f2] w-full flex justify-center p-2"
              >
                <FaTwitter />
              </a>
              <a
                href="https://www.facebook.com/share.php?u=https%3A%2F%2Fmicroexpressionstrainingvideos.com%2Fmembers%2F"
                target="_blank"
                className="mx-2 bg-[#1877f2] w-full flex justify-center p-2"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.linkedin.com/cws/share?url=https%3A%2F%2Fmicroexpressionstrainingvideos.com%2Fmembers%2F"
                target="_blank"
                className="mx-2 bg-[#2767b1] w-full flex justify-center p-2"
              >
                <FaLinkedinIn />
              </a>
            </div>
            <div className="mt-16 mb-4">
              {t(
                "Embed the free Micro Expressions Test on your website with this code"
              )}
              :
            </div>
            <textarea
              className="text-black w-[70%] md:w-[40%]"
              style={{ minHeight: 150 }}
              value={`<iframe allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" src="https://metv.microexpressionstrainingvideos.com/micro-expressions-test/" width="100%" height="950"></iframe>`}
            ></textarea>
          </div>
          <div className="col-span-3 md:col-span-1">
            <div>
              {/* <div className="text-center mt-4 text-lg">
                <div>Thank you for completing our Micro Expressions Test.</div>
                <div>
                  Your results have been stored and sent to the organizer.
                </div>
              </div> */}
              <section className="mt-8">
                <div className="flex flex-col items-center justify-center px-6 mx-auto lg:py-0">
                  <div className="w-full bg-white/[.6] rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700 ">
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                      <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                        Follow our 2 month Body Language e-Course for FREE
                      </h1>
                      <form
                        className="space-y-4 md:space-y-6"
                        // onSubmit={handleSubmit}
                        accept-charset="UTF-8"
                        action="https://www.aweber.com/scripts/addlead.pl"
                        method="post"
                      >
                        <input
                          type="hidden"
                          name="meta_web_form_id"
                          value="1443349639"
                        />
                        <input type="hidden" name="meta_split_id" value="" />
                        <input
                          type="hidden"
                          name="listname"
                          value="cfbodylanguage"
                        />
                        <input
                          type="hidden"
                          name="redirect"
                          value="http://www.centerforbodylanguage.com/checkyouremail"
                          id="redirect_d1f0bd81baeeb96a2e850c67ba16fc91"
                        />
                        <input
                          type="hidden"
                          name="meta_adtracking"
                          value="metest-end-of-test"
                        />
                        <input type="hidden" name="meta_message" value="1" />
                        <input
                          type="hidden"
                          name="meta_required"
                          value="name,email"
                        />
                        <input
                          type="hidden"
                          name="meta_tooltip"
                          value="name||Firstname Lastname,,email||your.email@email.com"
                        />
                        <div>
                          <label
                            htmlFor="name"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            Full Name
                          </label>
                          <input
                            type="string"
                            name="name"
                            id="fullname"
                            className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="First name Last name "
                            required
                            value={fullname}
                            onChange={(e) => setFullname(e.target.value)}
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="email"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            Your email
                          </label>
                          <input
                            type="string"
                            name="email"
                            id="email"
                            className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="name@company.com"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                        <button
                          type="submit"
                          className="w-full text-white bg-orange-500 hover:bg-orange-600 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 transition"
                        >
                          Yes, send me the e-Course!
                        </button>
                      </form>
                      <div className="text-black text-sm text-center text-bold dark:text-white">
                        Each week you will receive a Video and Photos around
                        different Body Language topics and an explanation about
                        their meaning. We respect your email privacy.
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinishSectionFree;
